var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfPack"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.FabricReport.PACKING_INFORMATION'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Confirmed_packing_information')))]),_c('a-radio-group',{attrs:{"name":"radioGroup"},model:{value:(_vm.freportPackinginformation),callback:function ($$v) {_vm.freportPackinginformation=$$v},expression:"freportPackinginformation"}},[_c('a-radio',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.yes')))]),_c('a-radio',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.no')))])],1)],1),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Roll_Packed_Details')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.fmediaRollpackeddetails,"otherData":{
          mediaName: '单卷面料封装方式',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaRollpackeddetails',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Shipping_Mark_Lable')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.fmediaShippingmark,"otherData":{
          mediaName: '唛头及产品标签',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaShippingmark',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Inner_Packing_Details')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.fmediaInnerpackingdetails,"otherData":{
          mediaName: '开包装产品展示',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaInnerpackingdetails',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.FabricReport.Collateral_Others')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfPack.fmediaCollateral,"otherData":{
          mediaName: '辅料/产品细节展示',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'fmediaCollateral',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }